import { render, staticRenderFns } from "./SearchBoxEmitente.vue?vue&type=template&id=19a09ca6&scoped=true"
import script from "./SearchBoxEmitente.vue?vue&type=script&lang=js"
export * from "./SearchBoxEmitente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a09ca6",
  null
  
)

export default component.exports